/**
 * キーボード操作（アクセシビリティ対応）。
 *  ・← → : 落下位置の移動
 *  ・スペース / Enter : 料理を落とす
 *  ・P : 一時停止・再開
 *  ・R : リスタート
 *
 * Phaser 側のキーボード入力は無効化してあるため、ここで一元管理する。
 */

import type { GameContext } from '../game/GameContext';

const EDITABLE_TAGS = new Set(['INPUT', 'TEXTAREA', 'SELECT']);

export class KeyboardController {
  private readonly context: GameContext;
  private readonly handler: (event: KeyboardEvent) => void;

  constructor(context: GameContext) {
    this.context = context;
    this.handler = (event) => this.onKeyDown(event);
    window.addEventListener('keydown', this.handler);
  }

  dispose(): void {
    window.removeEventListener('keydown', this.handler);
  }

  private onKeyDown(event: KeyboardEvent): void {
    if (event.repeat && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

    const target = event.target as HTMLElement | null;
    if (target && EDITABLE_TAGS.has(target.tagName)) return;

    const bus = this.context.bus;

    switch (event.key) {
      case 'ArrowLeft':
        event.preventDefault();
        bus.emit('command:move', { direction: -1 });
        break;
      case 'ArrowRight':
        event.preventDefault();
        bus.emit('command:move', { direction: 1 });
        break;
      case ' ':
      case 'Spacebar':
      case 'Enter':
        // ボタンにフォーカスがある場合はボタン操作を優先する
        if (target?.tagName === 'BUTTON') return;
        event.preventDefault();
        bus.emit('command:drop');
        break;
      case 'p':
      case 'P':
        event.preventDefault();
        bus.emit('command:togglePause');
        break;
      case 'r':
      case 'R':
        event.preventDefault();
        bus.emit('command:requestRestart');
        break;
      default:
        break;
    }
  }
}
